export default __webpack_public_path__ + "static/media/copyRight.1395ad0b.txt";